import Axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { i18n } from "src/i18n";
import { i18nInterceptor } from "src/interceptors";
import { baseDataKeys } from "src/query-keys";
import { Language, APIError } from "src/types";

export function useLanguages() {
  async function queryFn() {
    const response = await Axios.get<Language[]>(`/planning-api/languages`);
    handleLanguageInterceptor(response.data);

    return response.data;
  }

  return useQuery<Language[], AxiosError<APIError>>(baseDataKeys.languages, queryFn, {
    onError: (error) => {},
  });
}

function handleLanguageInterceptor(availableLanguages: Language[]) {
  const browserLanguage = navigator.language;
  const language = i18n.language;

  const isBrowserLanguageAvailiable = availableLanguages.some((lang) => lang.key === browserLanguage);
  const isi18nLanguageAvailable = availableLanguages.some((lang) => lang.key === language);

  if (isi18nLanguageAvailable) return i18nInterceptor(language);
  if (isBrowserLanguageAvailiable) return i18nInterceptor(browserLanguage);
  const [firstLanguage] = availableLanguages;

  return i18nInterceptor(firstLanguage.key);
}
